import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';

import { IconAlertTriangle, IconWind } from '@tabler/icons-react';

import styles from './current-weather.module.css';

export default function CurrentWeather({ handleWeatherClick, weatherData, isExtremeWeather, getWindDirection }) {
    return (
        <div 
        className={`${styles.currentWeather} ${styles.clickable}`}
        onClick={() => handleWeatherClick(weatherData.current, true)}
      >
        <div className={styles.timeDisplay}>
          <Typography variant="body2">
            Current as of {dayjs().tz('America/Toronto').format('h:mm A')}
          </Typography>
        </div>
        <div className={styles.mainWeather}>
          <div className={styles.temperature}>
            <span className={styles.tempValue}>{weatherData.current.temperature}°</span>
            <span className={styles.tempUnit}>C</span>
          </div>
          <div className={styles.conditions}>
            <Typography variant="h6">
              {weatherData.current.conditions}
              {isExtremeWeather && (
                <IconAlertTriangle size={20} className={styles.warningIcon} />
              )}
            </Typography>
            <Typography variant="body2">
              {weatherData.current.precipitation.probability}% chance of {weatherData.current.precipitation.type || 'precipitation'}
            </Typography>
          </div>
        </div>
        <div className={styles.weatherDetails}>
          <div className={styles.detailItem}>
            <Typography variant="body2">Wind Speed</Typography>
            <Typography variant="body1">{weatherData.current.wind.speed} km/h</Typography>
          </div>
          <div className={styles.detailItem}>
            <Typography variant="body2">Wind Direction</Typography>
            <div className={styles.windDirection}>
              <IconWind 
                size={20} 
                style={{ 
                  transform: `rotate(${weatherData.current.wind.direction}deg)`,
                  marginRight: '8px'
                }} 
              />
              <Typography variant="body1">
                {getWindDirection(weatherData.current.wind.direction)}
              </Typography>
            </div>
          </div>
        </div>
      </div>
    )
}